var map = {
	"./baic.jpg": "b04b",
	"./changan.jpg": "e250",
	"./chery.jpg": "ee2c",
	"./citroen.jpg": "9f5c",
	"./exeed.jpg": "be76",
	"./faw.jpg": "bf84",
	"./geely.jpg": "c5d3",
	"./haval.jpg": "9428",
	"./hyundai.jpg": "e4ba",
	"./jaecoo.jpg": "1774",
	"./jetta.jpg": "063c",
	"./kaiyi.jpg": "d3a2",
	"./lada.jpg": "b266",
	"./land-rover.jpg": "e183",
	"./lexus.jpg": "2676",
	"./livan.jpg": "6bfa",
	"./mg.jpg": "8686",
	"./moskvich.jpg": "dbed",
	"./omoda-new.jpg": "dbc2",
	"./omoda.jpg": "21dd",
	"./peugeot.jpg": "1011",
	"./skoda.jpg": "b0a4",
	"./skywell.jpg": "0984",
	"./toyota.jpg": "f2bf",
	"./volkswagen.jpg": "be47"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7bda";